import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AppComponent} from 'src/app/app.component';
import {Hotel} from 'src/app/core/viewModel/hotel';
import {HotelService} from '../../core/services/hotel.service';

@Component({
    selector: 'app-categorias-hoteis',
    templateUrl: './categorias-hoteis.component.html',
    styleUrls: ['./categorias-hoteis.component.sass']
})
export class CategoriasHoteisComponent implements OnInit {

    @Input() page?: string;
    destaqueList: Hotel[] = [];
    premiumList: Hotel[] = [];
    novoList: Hotel[] = [];

    constructor(
        public hotelService: HotelService,
        private router: Router,
        private appComponent: AppComponent) { }

    async ngOnInit() {
        if (this.page === undefined) {
            this.page = 'home';
        }
        this.appComponent.showOverlay();

        await this.loadHoteisDestaque();
        await this.loadHoteisPremium();
        await this.loadHoteisNovo();

        this.appComponent.hideOverlay();
    }

    async loadHoteisDestaque() {
        const result = this.hotelService.buscaHoteisDestaqueEstatico(36);
        let data = [];
        if (result) {
            data = result.data;
        }
        this.destaqueList = data;
    }

    async loadHoteisPremium() {
        const result = this.hotelService.buscaHoteisDestaqueEstatico(39);
        let data = [];
        if (result) {
            data = result.data;
        }
        this.premiumList = data;
    }

    async loadHoteisNovo() {
        const result = this.hotelService.buscaHoteisDestaqueEstatico(0);
        let data = [];
        if (result) {
            data = result.data;
        }
        this.novoList = data;
    }

    navegarParaDetalheHotel(item): void {
        const param = item.codContrato + '_' + item.slug;
        this.router.navigate(['/hoteis/hotel/', param]);
    }

    hotelDescricao(descricao: string) {
        if (descricao !== null) {
            return descricao.length > 350 ? descricao.substring(0, 350) : descricao;
        }
        return '';

    }
}
